"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseShoppingCart = void 0;
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
class BaseShoppingCart {
    constructor(productSKUs) {
        this.productSKUs = productSKUs;
        this.normalizeCart();
        this.validate();
    }
    /**
     * Normalize cart by checking whether there is the same product sku
     * in the cart or not, if there is then combine it together
     */
    normalizeCart() {
        this.productSKUs = this.productSKUs.reduce((productSKUs, currentProductSKU) => {
            const sameProductSKUsInCart = productSKUs.filter((productSKU) => productSKU.id === currentProductSKU.id);
            if (!sameProductSKUsInCart.length) {
                return productSKUs.concat([currentProductSKU]);
            }
            const someProductSKUHasSameOptionsAndNote = sameProductSKUsInCart.some((sameProductSKU) => (0, lodash_isequal_1.default)(sameProductSKU.options, currentProductSKU.options) &&
                (0, lodash_isequal_1.default)(sameProductSKU.note, currentProductSKU.note));
            if (!someProductSKUHasSameOptionsAndNote) {
                return productSKUs.concat([currentProductSKU]);
            }
            return productSKUs.map((productSKU) => {
                if (productSKU.id !== currentProductSKU.id) {
                    return productSKU;
                }
                const hasSameOptionsAndNote = (0, lodash_isequal_1.default)(productSKU.options, currentProductSKU.options) && (0, lodash_isequal_1.default)(productSKU.note, currentProductSKU.note);
                if (!hasSameOptionsAndNote) {
                    return productSKU;
                }
                return Object.assign(Object.assign({}, productSKU), { amount: productSKU.amount + currentProductSKU.amount });
            });
        }, []);
    }
    /**
     * Validate product skus whether there are enough stock for
     * given amount or not
     */
    validate() {
        this.productSKUs = this.productSKUs
            .map((productSKU) => {
            if (productSKU.stock <= 0) {
                return undefined;
            }
            if (productSKU.amount > productSKU.stock) {
                return Object.assign(Object.assign({}, productSKU), { amount: productSKU.stock });
            }
            return productSKU;
        })
            .filter(Boolean);
    }
    /**
     * Add items to productSKU
     * @param productSKUs
     * @returns {this}
     */
    addItems(productSKUs) {
        this.productSKUs = this.productSKUs.concat(productSKUs);
        this.normalizeCart();
        this.validate();
        return this;
    }
    /**
     * Remove item from productSKU
     * @param id
     * @returns {this}
     */
    deleteItemById(id, amount) {
        this.productSKUs = this.productSKUs
            .map((productSKU) => {
            if (productSKU.id !== id) {
                return productSKU;
            }
            if (amount) {
                const remainingAmount = productSKU.amount - amount;
                if (remainingAmount > 0) {
                    return Object.assign(Object.assign({}, productSKU), { amount: productSKU.amount - amount });
                }
            }
            return undefined;
        })
            .filter(Boolean);
        this.normalizeCart();
        this.validate();
        return this;
    }
    /**
     * Get product skus
     * @returns {ReadonlyArray<ProductSKU>}
     */
    getProductSKUs() {
        return this.productSKUs;
    }
}
exports.BaseShoppingCart = BaseShoppingCart;
//# sourceMappingURL=base.js.map